export const transformDataAndUpdateAddress = (
    data,
    dataProvider,
    handleError
) => {
    const { address, ...rest } = data;
    const { id: addressId, ...addressData } = address;

    if (addressId) {
        dataProvider
            .update("addresses", {
                id: addressId,
                data: addressData,
            })
            .catch((e) => handleError(e));
    }

    return rest;
};
